import { ACTION_TYPES, CUSTOM_CONSTANTS } from "Constants";
import _ from "lodash";

const initialState = {
  timezone: localStorage.getItem("timezone") || null,
  latitude: localStorage.getItem("latitude") || null,
  longitude: localStorage.getItem("longitude") || null,
};

const timezoneReducer = (state = initialState, action) => {
 // console.log('localStorage.getItem("timezone")-->',localStorage.getItem("timezone"));
 // console.log('localStorage.getItem("latitude")-->',localStorage.getItem("latitude"));
 // console.log('localStorage.getItem("longitude")-->',localStorage.getItem("longitude"));
  switch (action.type) {
    case ACTION_TYPES.TIMEZONE: {
      if (!_.isEmpty(action?.payload)) {
        localStorage.setItem("timezone", action.payload);
      }
      return {
        ...state,
        timezone: action.payload,
      };
    }
    case ACTION_TYPES.LATITUDE: {
      if (action.payload) {
        localStorage.setItem("latitude", action.payload);
      }
      return {
        ...state,
        latitude: action.payload,
      };
    }
    case ACTION_TYPES.LONGITUDE: {
      if (action.payload) {
        localStorage.setItem("longitude", action.payload);
      }
      return {
        ...state,
        longitude: action.payload,
      };
    }
    default:
      return state;
  }
};

export default timezoneReducer;
